import { Component, Injector, Input } from '@angular/core';
import { BaseComponent } from 'src/app/shared/baseComponent';

@Component({
  selector: 'app-lessonplan',
  templateUrl: './lessonplan.component.html',
  styleUrls: ['./lessonplan.component.css']
})
export class LessonplanComponent extends BaseComponent {
  @Input() scenario: any;
  @Input() saveFn?: () => Promise<void>;
  @Input() reloadFn?: () => Promise<void>;

  // local UI state
  showLessonplanStepPropertyModal = false;
  showLessonplanStepModal = false;
  lessonplanStep: any = {};
  hasUI = false; // derived from class === 'LessonPlanStepUI'
  showLessonplanStepInfo = false;
  // Allowed interactivity classes helper UI
  allowedInteractivityClasses: string[] = ['Grass', 'ModalHandler', 'Fire', 'Smoke'];
  showInteractivityClassList = false;
  allowedModalIds: string[] = ['navigationModalId', 'scenarioModalId', 'inviteWithUrlModalId'];
  showModalIdList = false;

  constructor(injector: Injector) {
    super(injector);
  }

  addLessonplanStep(step: any) {
    if (step == null) {
      this.lessonplanStep = {
        id: Array.from({ length: 6 }, () => String.fromCharCode(97 + Math.floor(Math.random() * 26))).join(''),
        name: 'Title',
        description: 'Text',
        seqNo: 10,
        panelSectionId: '',
        class: 'LessonPlanStep'
      };
      if (!this.scenario.lessonplan) { this.scenario.lessonplan = []; }
      this.scenario.lessonplan.push(this.lessonplanStep);
      this.hasUI = false;
      this.showLessonplanStepPropertyModal = true;
    } else {
      this.lessonplanStep = step;
      if (this.lessonplanStep.panelSectionId == null) {
        this.lessonplanStep.panelSectionId = '';
      }
      this.migrateLegacyUI(this.lessonplanStep);
      this.hasUI = this.lessonplanStep.class === 'LessonPlanStepUI';
      if (!this.lessonplanStep.class) {
        this.lessonplanStep.class = this.hasUI ? 'LessonPlanStepUI' : 'LessonPlanStep';
      }
      this.showLessonplanStepModal = true;
    }
  }

  updateLessonplanStepProperty() {
    this.showLessonplanStepPropertyModal = false;
    this.showLessonplanStepModal = true;
  }

  async saveLessonplanStep() {
    this.loader.show();
    try {
      // ensure fields align with selected class
      if (this.hasUI) {
        this.lessonplanStep.class = 'LessonPlanStepUI';
        this.ensureUIFields();
      } else {
        this.lessonplanStep.class = 'LessonPlanStep';
        this.stripUIFields();
      }

      this.showLessonplanStepModal = false;
      if (this.saveFn) { await this.saveFn(); }
      if (this.reloadFn) { await this.reloadFn(); }
    } finally {
      this.loader.hide();
    }
  }

  async deleteLessonplanStep(step: any) {
    this.loader.show();
    try {
      this.scenario.lessonplan = this.scenario.lessonplan.filter((s: any) => s.id != step.id);
      if (this.saveFn) { await this.saveFn(); }
      if (this.reloadFn) { await this.reloadFn(); }
    } finally {
      this.loader.hide();
    }
  }

  onHasUIChanged(val: boolean) {
    this.hasUI = val;
    if (this.hasUI) {
      this.lessonplanStep.class = 'LessonPlanStepUI';
      this.ensureUIFields();
    } else {
      this.lessonplanStep.class = 'LessonPlanStep';
      this.stripUIFields();
    }
  }

  pickInteractivityClass(name: string) {
    this.ensureUIFields();
    this.lessonplanStep.interactivityClass = name;
  }

  pickModalId(name: string) {
    this.ensureUIFields();
    this.lessonplanStep.modalId = name;
  }

  onClassChanged(value: string) {
    this.hasUI = value === 'LessonPlanStepUI';
    if (this.hasUI) {
      this.ensureUIFields();
    } else {
      this.stripUIFields();
    }
  }

  private ensureUIFields() {
    if (this.lessonplanStep.class !== 'LessonPlanStepUI') return;
    if (this.lessonplanStep.buttonText == null) this.lessonplanStep.buttonText = '';
    if (this.lessonplanStep.interactivityClass == null) this.lessonplanStep.interactivityClass = '';
    if (this.lessonplanStep.modalId == null) this.lessonplanStep.modalId = '';
  }

  private stripUIFields() {
    delete this.lessonplanStep.buttonText;
    delete this.lessonplanStep.interactivityClass;
    delete this.lessonplanStep.modalId;
  }

  private migrateLegacyUI(step: any) {
    if (step.UI) {
      // legacy structure: move nested UI fields to flat structure
      const ui = step.UI;
      if (ui.buttonText != null && step.buttonText == null) step.buttonText = ui.buttonText;
      if (ui.interactivityClass != null && step.interactivityClass == null) step.interactivityClass = ui.interactivityClass;
      if (ui.modalId != null && step.modalId == null) step.modalId = ui.modalId;
      delete step.UI;
      step.class = 'LessonPlanStepUI';
    }
  }
}
